import { Navigate, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/$workspaceSlug/$projectSlug/")({
  component: ProjectHome,
});

function ProjectHome() {
  const params = Route.useParams();
  return <Navigate to="/$workspaceSlug/$projectSlug/triage" params={params} replace />;
}
